module.exports = __webpack_public_path__ + "img/user.7ef784d0.png";